import React, { useState, useEffect, useRef } from 'react';

/**
 * 分页状态管理Hook
 * @param {Object} options - 配置选项
 * @param {number} options.defaultCurrent - 默认当前页
 * @param {number} options.defaultPageSize - 默认每页大小
 * @param {Function} options.onChange - 分页变化回调
 */
const usePagination = (options = {}) => {
  const {
    defaultCurrent = 1,
    defaultPageSize = 10,
    onChange
  } = options;

  const [current, setCurrent] = useState(defaultCurrent);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);
  const isFirstRender = useRef(true);

  // 当分页参数变化时触发回调，但初始化时不执行
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    
    if (onChange) {
      onChange(current, pageSize);
    }
  }, [current, pageSize]);

  // 重置到第一页
  const reset = () => {
    setCurrent(1);
  };

  // 设置数据总数
  const setTotalCount = (count) => {
    setTotal(count);
  };

  // 更新数据
  const updateData = (newData) => {
    setData(newData);
  };

  return {
    // 状态
    current,
    pageSize,
    total,
    data,

    // 操作方法
    setCurrent,
    setPageSize,
    setTotal: setTotalCount,
    setData: updateData,
    reset,
    goToPage: (page) => setCurrent(page),
    changePageSize: (size) => {
      setPageSize(size);
      // 重置到第一页
      setCurrent(1);
    },
    nextPage: () => {
      if (current < Math.ceil(total / pageSize)) {
        setCurrent(current + 1);
      }
    },
    prevPage: () => {
      if (current > 1) {
        setCurrent(current - 1);
      }
    },

    // 用于Pagination组件的props
    pagination: {
      current,
      pageSize,
      total,
      onChange: (page, size) => {
        setCurrent(page);
        setPageSize(size);
      }
    }
  };
};

export default usePagination;